<template>
  <div class="tax-table-wrap" :class="[`tax-status-${taxData.status}`]" v-if="isInit">
    <dl class="tax-table-header">
      <dt>增值税及附加税费申报表附列资料(五)<br />（附加税费情况表）</dt>

      <dd>
        <div>
          纳税人名称（公章）：{{ staticConfig.companyName }}（一般纳税人）
          <br />
          纳税人识别号（统一社会信用代码）：{{ staticConfig.creditCode }}
        </div>

        <div>
          税款所属期：{{ staticConfig.taxStartTime }} ~ {{ staticConfig.taxEndTime }}<br />
          填报日期：{{ staticConfig.fillFormDate }}
        </div>

        <div>单位：元至角分</div>
      </dd>
    </dl>

    <div class="tax-table-body">
      <table class="table1">
        <thead>
          <tr>
            <td colspan="27">申报表信息</td>
          </tr>
          <tr>
            <td colspan="4" rowspan="2" class="td-center">本期是否适用小微企业“六税两费”减征政策：</td>
            <td colspan="4" rowspan="2" class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v11x1" :mode="mode">
                <template #input>
                  <el-radio-group v-model="data.v11x1.value">
                    <el-radio value="1">是</el-radio>
                    <el-radio value="2">否</el-radio>
                  </el-radio-group>
                </template>
                <template #score>
                  <el-radio-group v-model="data.v11x1.answer">
                    <el-radio value="1">是</el-radio>
                    <el-radio value="2">否</el-radio>
                  </el-radio-group>

                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v11x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                    style="max-width: 200px"
                  />
                </template>
              </taxQue>
            </td>
            <td colspan="2" class="td-center">减征政策适用主体</td>
            <td colspan="6" class="td-center">
              <!-- 考题 -->
              <taxQue :data="data.v11x2" :mode="mode">
                <template #input>
                  <el-radio-group v-model="data.v11x2.value">
                    <el-radio value="1">个体工商户</el-radio>
                    <el-radio value="2">小型微利企业</el-radio>
                  </el-radio-group>
                </template>
                <template #score>
                  <el-radio-group v-model="data.v11x2.answer">
                    <el-radio value="1">个体工商户</el-radio>
                    <el-radio value="2">小型微利企业</el-radio>
                  </el-radio-group>

                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v11x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                    style="max-width: 200px"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
          <tr>
            <td colspan="2" class="td-center">适用减征政策起止时间</td>
            <td colspan="6" class="td-center">{{ staticConfig.taxStartTime }} 至 {{ staticConfig.taxEndTime }}</td>
          </tr>
          <tr>
            <td colspan="3" rowspan="3" class="td-center">税（费）种</td>
            <td colspan="3" class="td-center">计税（费）依据</td>
            <td rowspan="2" class="td-center">税（费）率（%）</td>
            <td rowspan="2" class="td-center">本期应纳税（费）额</td>
            <td colspan="2" class="td-center">本期减免税（费）额</td>
            <td colspan="2" class="td-center">小微企业“六税两费”减征政策</td>
            <td colspan="2" class="td-center">试点建设培育产教融合型企业</td>
            <td rowspan="2" class="td-center">本期已缴税（费）额</td>
            <td rowspan="2" class="td-center">本期应补（退）税（费）额</td>
          </tr>
          <tr>
            <td class="td-center">增值税税额</td>
            <td class="td-center">增值税免抵税额</td>
            <td class="td-center">留抵退税本期扣除额</td>
            <td class="td-center">减免性质代码</td>
            <td class="td-center">减免税（费）额</td>
            <td class="td-center">减征比例（%）</td>
            <td class="td-center" style="width: 80px">减征额</td>
            <td class="td-center">减免性质代码</td>
            <td class="td-center">本期抵免金额</td>
          </tr>
          <tr>
            <td class="td-center">1</td>
            <td class="td-center">2</td>
            <td class="td-center">3</td>
            <td class="td-center">4</td>
            <td class="td-center">5=（1+2-3）×4</td>
            <td class="td-center">6</td>
            <td class="td-center">7</td>
            <td class="td-center">8</td>
            <td class="td-center">9=(5-7)*8</td>
            <td class="td-center">10</td>
            <td class="td-center">11</td>
            <td class="td-center">12</td>
            <td class="td-center">13=5-7-9-11-12</td>
          </tr>
        </thead>
        <tbody class="read-mode">
          <tr>
            <td colspan="2" class="td-center" style="width: 140px">城市维护建设税</td>
            <td class="td-center" style="width: 40px">1</td>
            <td>
              <!-- 数据自动关联 -->
              {{ parseFloatNum(data.v1x1.value) }}
            </td>
            <td>
              <el-input-number v-model.trim="data.v1x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v1x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td style="width: 100px">
              <el-select v-model.trim="data.v1x4.value">
                <el-option value="0.05" label="5.0%" />
                <el-option value="0.07" label="7.0%" />
              </el-select>
            </td>
            <td>{{ parseFloatNum(data.v1x5.value) }}</td>
            <td>
              <el-input-number v-model.trim="data.v1x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v1x7.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td class="td-center">{{ parseFloatNum(data.v1x8.value * 100) }}</td>
            <td class="td-center">{{ parseFloatNum(data.v1x9.value) }}</td>
            <td class="td-center">--</td>
            <td class="td-center">--</td>
            <td>
              <el-input-number v-model.trim="data.v1x12.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v1x13.value) }}</td>
          </tr>
          <tr>
            <td colspan="2" class="td-center" style="width: 5%">教育费附加</td>
            <td class="td-center">2</td>
            <td>
              <!-- 数据自动关联 -->
              {{ parseFloatNum(data.v2x1.value) }}
            </td>
            <td>
              <el-input-number v-model.trim="data.v2x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v2x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ data.v2x4.value * 100 }}%</td>
            <td>{{ parseFloatNum(data.v2x5.value) }}</td>
            <td>
              <el-input-number v-model.trim="data.v2x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v2x7.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td class="td-center">{{ parseFloatNum(data.v2x8.value * 100) }}</td>
            <td class="td-center">{{ parseFloatNum(data.v2x9.value) }}</td>
            <td>
              <el-input-number v-model.trim="data.v2x10.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v2x11.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v2x12.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v2x13.value) }}</td>
          </tr>
          <tr>
            <td colspan="2" class="td-center">地方教育附加</td>
            <td class="td-center">3</td>
            <td>
              <!-- 数据自动关联 -->
              {{ parseFloatNum(data.v3x1.value) }}
            </td>
            <td>
              <el-input-number v-model.trim="data.v3x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v3x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ data.v3x4.value * 100 }}%</td>
            <td>{{ parseFloatNum(data.v3x5.value) }}</td>
            <td>
              <el-input-number v-model.trim="data.v3x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v3x7.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td class="td-center">{{ parseFloatNum(data.v3x8.value * 100) }}</td>
            <td class="td-center">{{ parseFloatNum(data.v3x9.value) }}</td>
            <td>
              <el-input-number v-model.trim="data.v3x10.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v3x11.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v3x12.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v3x13.value) }}</td>
          </tr>
          <tr>
            <td colspan="2" class="td-center">合计</td>
            <td class="td-center">4</td>
            <td class="td-center">--</td>
            <td class="td-center">--</td>
            <td class="td-center">--</td>
            <td class="td-center">--</td>
            <td>{{ parseFloatNum(data.v4x5.value) }}</td>
            <td class="td-center">--</td>
            <td>{{ parseFloatNum(data.v4x7.value) }}</td>
            <td class="td-center">--</td>
            <td class="td-center">{{ parseFloatNum(data.v4x9.value) }}</td>
            <td class="td-center">--</td>
            <td>{{ parseFloatNum(data.v4x11.value) }}</td>
            <td>{{ parseFloatNum(data.v4x12.value) }}</td>
            <td>{{ parseFloatNum(data.v4x13.value) }}</td>
          </tr>
          <tr>
            <td colspan="6" rowspan="3" class="td-center">本期是否适用试点建设培育产教融合型企业抵免政策</td>
            <td rowspan="3">
              <el-radio-group v-model="data.v11x3.value" style="flex-direction: column">
                <el-radio value="1" style="margin: 0">是</el-radio>
                <el-radio value="-1">否</el-radio>
              </el-radio-group>
            </td>
            <td colspan="6" class="td-center">当期新增投资额</td>
            <td>5</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v5x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td colspan="6" class="td-center">上期留抵可抵免金额</td>
            <td>6</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v6x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td colspan="6" class="td-center">结转下期可抵免金额</td>
            <td>7</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v7x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td colspan="7" rowspan="3" class="td-center">可用于扣除的增值税留抵退税额使用情况</td>
            <td colspan="6" class="td-center">当期新增可用于扣除的留抵退税额</td>
            <td>8</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v8x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td colspan="6" class="td-center">上期结存可用于扣除的留抵退税额</td>
            <td>9</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v9x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
          <tr>
            <td colspan="6" class="td-center">结转下期可用于扣除的留抵退税额</td>
            <td>10</td>
            <td colspan="2">
              <el-input-number v-model.trim="data.v10x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { cloneDeep } from "lodash";
import Big from "big.js";
import { reportTaxDateConfig } from "../../reportTaxStaticConfig.js";
import taxQue from "../../cmp/taxQue.vue";

const currentQa = inject("provideCurrentQa");
const staticConfig = computed(() => reportTaxDateConfig(currentQa.value).staticConfig);

const isInit = ref(false);
const mode = ref(null);

// 初始数据
const taxDataAll = ref({});
const taxData = ref({});
const data = ref({});
// 初始化
const init = (options = {}) => {
  mode.value = options.mode;
  taxDataAll.value = cloneDeep(options.taxDataAll);
  // 当前数据
  taxData.value = cloneDeep(options.taxData);
  // 当前数据的表单数据
  data.value = cloneDeep(options.taxData.data);
  watchStart();
  isInit.value = true;
};
// 返回数据
const getData = () => {
  if (!isInit.value) {
    return;
  }

  return toRaw(data.value);
};

function watchStart() {
  watch(
    data,
    (newVal, oldVal) => {
      try {
        // 1-3行
        for (let row = 1; row <= 3; row++) {
          // 5=（1+2-3）×4
          data.value[`v${row}x5`].value = new Big(new Big(data.value[`v${row}x1`].value).plus(data.value[`v${row}x2`].value).minus(data.value[`v${row}x3`].value))
            .times(data.value[`v${row}x4`].value)
            .round(2)
            .toNumber();
          // 9=(5-7)*8
          data.value[`v${row}x9`].value = new Big(new Big(data.value[`v${row}x5`].value).minus(data.value[`v${row}x7`].value)).times(data.value[`v${row}x8`].value).round(2).toNumber();
          // 13=5-7-9-11-12
          data.value[`v${row}x13`].value = new Big(data.value[`v${row}x5`].value)
            .minus(data.value[`v${row}x7`].value)
            .minus(data.value[`v${row}x9`].value)
            .minus(data.value[`v${row}x11`].value)
            .minus(data.value[`v${row}x12`].value)
            .round(2)
            .toNumber();
        }
        // 5,7,9,11,12,13列
        [5, 7, 9, 11, 12, 13].forEach((column) => {
          // 4=1+2+3
          data.value[`v4x${column}`].value = new Big(data.value[`v1x${column}`].value).plus(data.value[`v2x${column}`].value).plus(data.value[`v3x${column}`].value).round(2).toNumber();
        });

        if (data.value.v11x1.value == 1) {
          data.value.v1x8.value = 0.5;
          data.value.v2x8.value = 0.5;
          data.value.v3x8.value = 0.5;
        } else {
          data.value.v1x8.value = 0;
          data.value.v2x8.value = 0;
          data.value.v3x8.value = 0;
        }
      } catch (e) {
        console.log(e);
      }
    },
    {
      deep: true,
      immediate: true,
    }
  );
}

// 小数点
function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {}
}

defineExpose({
  init,
  getData,
});
</script>

<style scoped lang="scss">
.tax-table-wrap {
  width: 1400px !important;
}
</style>

<script>
const tableHtml = `
<table class="table1">
  <thead>
    <tr>
      <td colspan="27">申报表信息</td>
    </tr>
    <tr>
      <td colspan="4" rowspan="2" class="td-center">本期是否适用小微企业“六税两费”减征政策：</td>
      <td colspan="4" rowspan="2" class="td-center">
        <div class="grid-radio">
          <label><span>是</span><input type="radio" name="addType" value="1" style="width: 20px" /></label>
          <label><span>否</span><input type="radio" name="addType" value="2" style="width: 20px" /></label>
        </div>
      </td>
      <td colspan="2" class="td-center">减征政策适用主体</td>
      <td colspan="6" class="td-center">
        <label><span>个体工商户</span><input type="radio" name="mainBody" value="1" style="width: 20px" /></label>
        <label><span>小型微利企业</span><input type="radio" name="mainBody" value="2" style="width: 20px" /></label>
      </td>
    </tr>
    <tr>
      <td colspan="2" class="td-center">适用减征政策起止时间</td>
      <td colspan="6" class="td-center">2022-09-01 至 2022-09-30</td>
    </tr>
    <tr>
      <td colspan="3" rowspan="3" class="td-center" style="width: 15%">税（费）种</td>
      <td colspan="3" class="td-center">计税（费）依据</td>
      <td rowspan="2" class="td-center">税（费）率（%）</td>
      <td rowspan="2" class="td-center">本期应纳税（费）额</td>
      <td colspan="2" class="td-center">本期减免税（费）额</td>
      <td colspan="2" class="td-center">小微企业“六税两费”减征政策</td>
      <td colspan="2" class="td-center">试点建设培育产教融合型企业</td>
      <td rowspan="2" class="td-center">本期已缴税（费）额</td>
      <td rowspan="2" class="td-center">本期应补（退）税（费）额</td>
    </tr>
    <tr>
      <td class="td-center">增值税税额</td>
      <td class="td-center">增值税免抵税额</td>
      <td class="td-center">留抵退税本期扣除额</td>
      <td class="td-center">减免性质代码</td>
      <td class="td-center">减免税（费）额</td>
      <td class="td-center">减征比例（%）</td>
      <td class="td-center">减征额</td>
      <td class="td-center">减免性质代码</td>
      <td class="td-center">本期抵免金额</td>
    </tr>
    <tr>
      <td class="td-center">1</td>
      <td class="td-center">2</td>
      <td class="td-center">3</td>
      <td class="td-center">4</td>
      <td class="td-center">5=（1+2-3）×4</td>
      <td class="td-center">6</td>
      <td class="td-center">7</td>
      <td class="td-center">8</td>
      <td class="td-center">9=(5-7)*8</td>
      <td class="td-center">10</td>
      <td class="td-center">11</td>
      <td class="td-center">12</td>
      <td class="td-center">13=5-7-9-11-12</td>
    </tr>
  </thead>
  <tbody class="read-mode">
    <tr>
      <td colspan="2" class="td-center" style="width: 10%">城市维护建设税</td>
      <td class="td-center">1</td>
      <td>
        <div validate="data_1_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_1_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_1_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_1_4">
          <select validate="data_1_4">
            <option value="0.05">5.0%</option>
            <option value="0.07">7.0%</option>
          </select>
        </div>
      </td>
      <td>
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td>
        <div validate="data_1_6" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_1_7" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td class="td-center">50.00</td>
      <td class="td-center"><input type="text" autocomplete="off" readonly="readonly" /></td>
      <td class="td-center">--</td>
      <td class="td-center">--</td>
      <td>
        <div validate="data_1_10" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
    </tr>
    <tr>
      <td colspan="2" class="td-center" style="width: 5%">教育费附加</td>
      <td class="td-center">2</td>
      <td>
        <div validate="data_2_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_2_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_2_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text alignRight"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td>
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td>
        <div validate="data_2_6" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_2_7" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td class="td-center">50.00</td>
      <td class="td-center"><input type="text" autocomplete="off" readonly="readonly" /></td>
      <td>
        <div validate="data_2_8" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_2_9" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_2_10" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
    </tr>
    <tr>
      <td colspan="2" class="td-center">地方教育附加</td>
      <td class="td-center">3</td>
      <td>
        <div validate="data_3_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_3_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_3_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text alignRight"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td>
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td>
        <div validate="data_3_6" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_3_7" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td class="td-center">50.00</td>
      <td class="td-center"><input type="text" autocomplete="off" readonly="readonly" /></td>
      <td>
        <div validate="data_3_8" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_3_9" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_3_10" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
    </tr>
    <tr>
      <td colspan="2" class="td-center">合计</td>
      <td class="td-center">4</td>
      <td class="td-center">--</td>
      <td class="td-center">--</td>
      <td class="td-center">--</td>
      <td class="td-center">--</td>
      <td>
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td class="td-center">--</td>
      <td>
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td class="td-center">--</td>
      <td class="td-center"><input type="text" autocomplete="off" readonly="readonly" /></td>
      <td class="td-center">--</td>
      <td>
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td>
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td>
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
    </tr>
    <tr>
      <td colspan="6" rowspan="3" class="td-center">本期是否适用试点建设培育产教融合型企业抵免政策</td>
      <td rowspan="3">
        <label><span>是</span><input type="radio" name="data_r_5" value="1" checked="checked" style="width: 20px" /></label>
        <label><span>否</span><input type="radio" name="data_r_5" value="-1" style="width: 20px" /></label>
      </td>
      <td colspan="6" class="td-center">当期新增投资额</td>
      <td>5</td>
      <td colspan="2">
        <div validate="data_5_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td colspan="6" class="td-center">上期留抵可抵免金额</td>
      <td>6</td>
      <td colspan="2">
        <div validate="data_6_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td colspan="6" class="td-center">结转下期可抵免金额</td>
      <td>7</td>
      <td colspan="2">
        <div validate="data_7_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td colspan="7" rowspan="3" class="td-center">可用于扣除的增值税留抵退税额使用情况</td>
      <td colspan="6" class="td-center">当期新增可用于扣除的留抵退税额</td>
      <td>8</td>
      <td colspan="2">
        <div validate="data_8_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td colspan="6" class="td-center">上期结存可用于扣除的留抵退税额</td>
      <td>9</td>
      <td colspan="2">
        <div validate="data_9_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
    <tr>
      <td colspan="6" class="td-center">结转下期可用于扣除的留抵退税额</td>
      <td>10</td>
      <td colspan="2">
        <div validate="data_10_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
    </tr>
  </tbody>
</table>
`;

function replaceHtml(str) {
  let s = str.replace(/(<div([^>]*)>)|(<\/div>)/gi, "");
  s = s.replace(/(<span([^>]*)>)|(<\/span>)/gi, "");
  s = s.replace(/<input type="text" autocomplete="off" \/>/g, '<el-input-number v-model.trim="defaultValueNum" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.00" />');

  return s;
}

const defaultValueNum = ref(0);
// console.log(replaceHtml(tableHtml), "tableHtml");
</script>
